const STATE_KEY = "__jamoraOverlay";
const activeOverlays = [];
let nextId = 0;
let previousState = typeof window === "undefined" ? null : window.history.state;

const marker = (state) => state?.[STATE_KEY];

function rememberCurrentEntry() {
  previousState = window.history.state;
}

if (typeof window !== "undefined") {
  // Registered before BrowserRouter: a back press reaches this handler first.
  window.addEventListener("popstate", (event) => {
    const departed = marker(previousState);
    const destination = marker(event.state);
    previousState = event.state;

    // A sheet dismissed with its close button leaves a duplicate entry at
    // the same URL. Skip that entry on the next back press.
    const departedIsDismissed = departed && (
      departed.status === "closed" ||
      !activeOverlays.some((overlay) => overlay.id === departed.id)
    );
    if (departedIsDismissed && departed.url === window.location.href) {
      window.history.go(-1);
      return;
    }

    const top = activeOverlays[activeOverlays.length - 1];
    if (top && destination?.id !== top.id) {
      top.close();
      return;
    }

    // A page change may unmount an overlay before its history entry is
    // revisited. Treat that entry as dismissed when the user returns to it.
    if (destination && !activeOverlays.some((overlay) => overlay.id === destination.id)) {
      window.history.replaceState(
        { ...event.state, [STATE_KEY]: { ...destination, status: "closed" } },
        "",
        window.location.href,
      );
      rememberCurrentEntry();
    }
  });
}

export function createOverlayId() {
  nextId += 1;
  return `overlay-${nextId}`;
}

export function registerOverlay(id, close) {
  const url = window.location.href;
  activeOverlays.push({ id, close, url });
  const current = window.history.state || {};
  const nextState = { ...current, [STATE_KEY]: { id, url, status: "open" } };

  if (marker(current)?.id === id) {
    window.history.replaceState(nextState, "", url);
  } else {
    window.history.pushState(nextState, "", url);
  }
  rememberCurrentEntry();

  return () => {
    const index = activeOverlays.findIndex((overlay) => overlay.id === id);
    if (index !== -1) activeOverlays.splice(index, 1);
    const state = window.history.state;
    if (marker(state)?.id === id && marker(state)?.status === "open") {
      window.history.replaceState(
        { ...state, [STATE_KEY]: { id, url, status: "closed" } },
        "",
        window.location.href,
      );
      rememberCurrentEntry();
    }
  };
}

export function syncOverlayHistory() {
  rememberCurrentEntry();
  const url = window.location.href;
  activeOverlays.filter((overlay) => overlay.url !== url).forEach((overlay) => overlay.close());
}
